import { FC } from 'react'

import styled, { useTheme } from 'styled-components'

import PauseIcon from 'src/Assets/Svg/player/pause.svg?react'
import PlayIcon from 'src/Assets/Svg/player/play.svg?react'
import { PrimaryLoading } from 'src/Components/PrimaryLoading'

const IconWrapper = styled.div`
  position: absolute;
  top: 26px;
  left: 26px;
`

const Loader = styled(PrimaryLoading)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

interface PlayerIconProps {
  isLoading: boolean
  isPlaying: boolean
}

export const PlayerIcon: FC<PlayerIconProps> = ({ isLoading, isPlaying }) => {
  const theme = useTheme()

  if (isLoading) {
    return (
      <IconWrapper>
        <Loader color={theme.color.white} fontSize={'30px'} />
      </IconWrapper>
    )
  }

  return <IconWrapper>{isPlaying ? <PauseIcon /> : <PlayIcon />}</IconWrapper>
}
